module.exports = __webpack_public_path__ + "static/media/empty-state-trips.14887a09.svg";